import { render, staticRenderFns } from "./GridContextMenu.vue?vue&type=template&id=5c852d70&scoped=true&"
import script from "./GridContextMenu.vue?vue&type=script&lang=js&"
export * from "./GridContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c852d70",
  null
  
)

export default component.exports